<body>
  
  <div id="container">
    <h4 class="text" id="firsttext">Create Course Fee Master</h4>
     <img  id="filter" src="../../../../../assets/image/filter.png" alt="" (click)="filterDisplay()">
    <button id="create" (click)="openCreateDialog()">Add</button>
    <hr>  
  
    <div id="tablecon">
      <div class="row ">
        <div class="col-md-12">
          <div class="table-responsive ">
            <table  id="table"
              class="table table-bordered  mb-0 table-striped table-hover text-center ">
              <thead class="table-dark text-center ">
                <tr >
                  <th class=" text-center ">YEAR</th>
                  <th class=" text-center ">ORIENTATION</th>
                  <th class=" text-center ">COURSE FEE</th>
                  <th class=" text-center ">CREATED ON</th>
                  <th class=" text-center ">APPROVED STATUS</th>
                  <th class=" text-center ">ACTION</th>
                </tr>
              </thead>
              <tbody id="tbody text-center">
                <tr *ngFor="let data of list;let i=index">
                  <td>{{data.academicYear}}</td>
                  <td>{{data.orientationType}}</td>
                  <td>{{data.previousFeeAmmount}}</td>
                  <td>{{data.createdOn}}</td>
                  <td>{{data.approvalStatus}}</td>
                  <td *ngIf="data.approvalStatus=='PENDING';else elseblock"><a ><img
                        src="../../../../../assets/image/canedit.svg" alt="" id="pendingImage"class="img-fluid" (click)="verifyCourseTrack2(i,true)"></a></td>
                  <ng-template #elseblock>
                    <td>
                      <img src="../../../../../assets/image/cannotEdit.svg" alt="" id="pendingImage" class="img-fluid">
                    </td>
                  </ng-template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div [style.display]="filterdisplay" class="filterContainer">
      <ul id="myList">
        <li (click)="changeFilter('pending')">Pending</li>
        <li (click)="changeFilter('approved')">Approved</li>
        <li (click)="changeFilter('rejected')">Rejected</li>
        <li (click)="closefilterDisplay()">Close</li>
    </ul>
    </div>
  </div>
  <app-footer></app-footer>
</body>
